import { isDev } from './index';

export const isZyncStaff = (userId) => {
  return userId.endsWith('@zync.ai') || isDev();
};
